<template>
  <v-autocomplete
    v-model="selectedSeat"
    :items="dropDownOwnSeats"
    item-title="description"
    label="Sitzplätze"
    density="compact"
    class="dropDownMenu"
    variant="solo"
    hide-details
    return-object
  ></v-autocomplete>
</template>

<script>
export default {
  props: {
    modelValue: { type: Object, default: () => null },
    dropDownOwnSeats: { type: Array, default: () => [] }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      selectedSeat: this.modelValue
    }
  },

  watch: {
    dropDownOwnSeats: {
      handler(val) {
        if (val.length > 0) {
            this.selectedSeat = val[0]
            this.$emit('update:modelValue', val[0])
        }
      },
      deep: true,
      immediate: true
    },

    selectedSeat(val) {
        this.$emit('update:modelValue', val)
    },

    modelValue(val) {
      this.selectedSeat = val
    }
  }
}
</script>

<style scoped>
.v-autocomplete {
  color: black;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  font-size: small;
  border-radius: 4px;
  width: auto;
  min-width: 14rem;
}
</style>
